import React from 'react'
import { withRouter } from 'react-router-dom'

import { Toast } from 'primereact/toast'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { AuthContext } from '../../main/ProvedorAutenticacao'

import NavBar from '../../componentes/Navbar'

import FaseService from '../../app/service/FaseService'

class Fases extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fase: null,
      fases: [],
      codigo: '',
      nome: '',
      modalFase: false,
      modalFaseAlterar: false,
      openSpinner: false,
    }

    this.faseService = new FaseService();

    this.acoes = this.acoes.bind(this);
    this.accept = this.accept.bind(this);
    this.renderFooterCadastroFases = this.renderFooterCadastroFases.bind(this);
    this.renderFooterAlterarFases = this.renderFooterAlterarFases.bind(this);
  }

  listarFases = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.faseService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({fases: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Fases', detail:`${this.state.detail}`, life: 4000});
      })
  }

  abrirModalCadastro(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.limparCampos();
    this.setState(state);
  }

  limparCampos() {
    this.setState({fase: null});
    this.setState({nome: ''});
  }

  acoes(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" 
                onClick={() => this.consultarFase(rowData)}
                tooltip="Editar Fase" 
                tooltipOptions={{position: 'top'}} />
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                onClick={() => this.confirmaExclusao(rowData)} 
                tooltip="Excluir Fase" 
                tooltipOptions={{position: 'top'}}/>
      </React.Fragment>
    );
  }

  confirmaExclusao(fase) {
    this.setState({codigo: fase.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir a Fase de Processo?',
        header: 'Exclusão de Fase de Processo',
        icon: 'pi pi-question-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.accept,
        reject: this.reject
    });
  }

  excluirFase() {
    this.setState({openSpinner: true});
    this.faseService.excluir(this.state.codigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Fases do Processo', detail:'Fase de Processo excluído com sucesso', life: 4000});
        this.listarFases();
      });
      this.setState({openSpinner: false});
  }

  accept() {
    this.excluirFase();
  }

  fecharModal(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  abrirModaAlterar(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }

    this.setState(state);
  }

  renderFooterCadastroFases(name) {
    return (
        <div>
            <Button label="Cadastrar" 
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrarFase}/> 
            &nbsp;
            <Button label="Cancelar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  renderFooterAlterarFases(name) {
    return (
        <div>
            <Button label="Alterar" 
                    className="p-button-primary p-button-text"
                    onClick={this.alterarFase}/> 
            &nbsp;
            <Button label="Cancelar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  async consultarFase(fase){
    this.setState({openSpinner: true});
    this.faseService.consultar(fase.codigo)
      .then(response => {
        this.setState({fase: response.data});
        this.setState({nome: response.data.nome});
        this.setState({codigo: response.data.codigo});
        this.abrirModaAlterar('modalFaseAlterar');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Fases do Processo', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  cadastrarFase = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;

    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Fases do Processo', detail:'O nome da Fase do Processo é obrigatório', life: 4000});
      return;
    }
    const fase = {
      nome: this.state.nome,
      empresa: usuarioLogado.empresa
    }

    this.setState({openSpinner: true});
    this.faseService.cadastrar(fase)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Fases do Processo', detail:'Fase do Processo cadastrado com sucesso', life: 4000});
        this.fecharModal('modalFase');
        this.listarFases();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Fases do Processo', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  alterarFase = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Fases do Processo', detail:'O nome da Fase do Processo é obrigatório', life: 4000});
      return;
    }

    const fase = {
      codigo: this.state.codigo,
      nome: this.state.nome,
      empresa: usuarioLogado.empresa
    }

    this.setState({openSpinner: true});
    this.faseService.alterar(fase)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Fases do Processo', detail:'Fase de Processo alterado com sucesso', life: 4000});
        this.fecharModal('modalFaseAlterar');
        this.listarFases();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Fases do Processo', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  async componentDidMount() {
    this.setState({openSpinner: true});
    await this.listarFases();
    this.setState({openSpinner: false});
  }

  render() {
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
        <div className="content-wrapper">
          {/**Cadastro de Fases de Processo */}
          <Dialog header="Cadastro de Fases de Processo"
                    visible={this.state.modalFase} 
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterCadastroFases('modalFase')} 
                    onHide={() => this.fecharModal('modalFase')}>
                
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="nomeFase">Nome</label>
                        <InputText id="nomeFase" 
                                   type="text" 
                                   value={this.state.nome}
                                   onChange={e => this.setState({nome: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                </div>
          </Dialog>
          {/**Alterar Fases de Processo */}
          <Dialog header="Alterar Tipos de Pedidos"
                    visible={this.state.modalFaseAlterar} 
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterAlterarFases('modalFaseAlterar')} 
                    onHide={() => this.fecharModal('modalFaseAlterar')}>
                
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="nomeFaseAlterar">Nome</label>
                        <InputText id="nomeFaseAlterar" 
                                   type="text" 
                                   value={this.state.nome}
                                   onChange={e => this.setState({nome: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                </div>
          </Dialog>
          <section className="content-header">
            <div className="container-fluid">
            <div className="row">
                <div className="col-md-12">
                  <div className="card card-primary card-outline">
                    <div className="card-header">
                      <h3 className="card-title">
                        <i className="pi pi-map"></i>
                        <span> Fases de Processo</span>
                      </h3>  
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-5">
                          <span className="input-group">
                            <button type="button" className="btn btn-primary bg-gradient-primary" 
                                    onClick={() => this.abrirModalCadastro('modalFase')}
                                    data-toggle="modal" 
                                    data-target="#modal-default">
                            <i className="fas fa-plus"></i> Adicionar</button>
                          </span>
                        </div>
                      </div>
                    </div>
                    <DataTable value={this.state.fases}  paginator responsiveLayout="scroll"
                      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" emptyMessage="Nenhuma fase cadastrada" rows={10}>
                      <Column field="nome" header="Nome"></Column>
                      <Column body={this.acoes} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    );
  }
}

Fases.contextType = AuthContext;
export default withRouter (Fases)